import { useTranslation } from "@/hooks/useTranslation"
import {
  TitleStepDeployTab,
  type CommonDeployTabProps
} from "@/pages/DeploymentsPage/components/molecules/DeployTab"
import { DownloadStep } from "@/pages/DeploymentsPage/components/organisms/DownloadStep"
import { ScriptDeployCommand } from "@/pages/DeploymentsPage/components/organisms/ScriptDeployCommand"
import {
  BUILD_GROUPS,
  getBuildLines,
  getImageDefaultValues,
  getKortexImage,
  getSensorsDockerfileLines,
  SENSORS_DOCKERFILE_GROUPS
} from "@/pages/DeploymentsPage/helpers/container-image"
import { getDockerRegcredFiles } from "@/pages/DeploymentsPage/helpers/file"

import type { StepItem } from "@/atoms"
import type {
  ContainerImageStepTitles,
  DockerPlatform,
  KortexImageName
} from "@/pages/DeploymentsPage/helpers/container-image.types"

// The steps that add the Kodem sensors to the user's image: download the Kodem
// registry credentials, add the sensors image to the Dockerfile, then build and
// push the image for the platform the service runs
export const useContainerImageSteps = (props: CommonDeployTabProps) => {
  const { noError, version } = props
  const { t } = useTranslation("translation", { keyPrefix: "deployments" })
  const { t: tGeneral } = useTranslation("translation", {
    keyPrefix: "general"
  })

  return (
    imageName: KortexImageName,
    platform: DockerPlatform,
    titles: ContainerImageStepTitles
  ): StepItem[] => [
    {
      title: (
        <DownloadStep
          noError={noError}
          files={getDockerRegcredFiles()}
          titlePrefix={tGeneral("download")}
          title={titles.download}
        />
      ),
      status: "process"
    },
    {
      title: (
        <TitleStepDeployTab prefix={t("add")}>
          {`- ${titles.dockerfile}`}
        </TitleStepDeployTab>
      ),
      description: (
        <ScriptDeployCommand
          lines={getSensorsDockerfileLines(getKortexImage(imageName, version))}
          groups={SENSORS_DOCKERFILE_GROUPS}
          {...props}
        />
      ),
      status: "process"
    },
    {
      title: (
        <TitleStepDeployTab prefix={t("build")}>
          {`- ${titles.build}`}
        </TitleStepDeployTab>
      ),
      description: (
        <ScriptDeployCommand
          lines={getBuildLines(platform)}
          groups={BUILD_GROUPS}
          getDefaultValues={getImageDefaultValues}
          {...props}
        />
      ),
      status: "process"
    }
  ]
}
